import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationHttpClient } from '@app/core/http';

import { Category } from '@app/core/models';


@Injectable({ providedIn: 'root' })
export class CategoryService {

  constructor(private http: ApplicationHttpClient) {
  }

  public getCategories(type: string) {
    if (type === 'diagnosticCode') {
      return this.http.get(`/api/app/category/type?type=${ type }`, {
      }).pipe(
        map(categories => {
          return categories.map(category => ({
            ...category,
            shortName: category.name.split(' - ')[0]
          }));
        })
      );
    }
    return this.http.get(`/api/app/category/type?type=${ type }`, {
    });
  }

  public filterCategories(filters = {}) {
    return this.http.getList('/api/app/category/search-code', {
      params: {
        ...filters
      }
    }).pipe(
      map(categories => {
        return categories.map(category => ({
          ...category,
          shortName: category.name.split(' - ')[0]
        }));
      })
    );
  }

  public getCategoryByTypeAndCode(type, code) {
    return this.http.get(`/api/app/category/type-code?type=${type}&code=${code}`, {
    });
  }

  public getByTypeAndCode(filters = {}) {
    return this.http.getList('/api/app/category/search-code', {
      params: {
        ...filters
      }
    }).pipe(
      map(categories => {
        return categories.map(category => ({
          ...category,
          shortName: category.name.split(' - ')[0]
        }));
      })
    );
  }
}
